module.exports = __webpack_public_path__ + "static/media/internet.7b7e5eaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vector/internet.svg
// module id = 27
// module chunks = 0